'use client';

import { c as _c } from "react/compiler-runtime";
import cookies from 'js-cookie';
import { useEffect, useState } from 'react';
export const ID_TOKEN_COOKIE = 'id_token';

/** Read synchronously — safe on the client only (guards for SSR, where `document` is absent). */
export function hasAuthTokenCookie(): boolean {
  return typeof document !== 'undefined' && cookies.get(ID_TOKEN_COOKIE) !== undefined;
}

/**
 * `undefined` until the first client pass. Callers must not conflate that with
 * "no cookie": these routes are prerendered, so reading `document.cookie`
 * during render risks a hydration mismatch, and acting on a premature `false`
 * lets a logged-in user's page take the anonymous branch.
 */
export function useHasAuthTokenCookie() {
  const $ = _c(2);
  const [hasToken, setHasToken] = useState(undefined);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setHasToken(hasAuthTokenCookie());
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return hasToken;
}